import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectFilterVisible, hideFilterMenu } from "reducers/filterMenu";
import { Transition } from "react-transition-group";
import { useOnClickOutside } from "helpers/useOnClickOutside";
//import { useLockBody } from "helpers/useLockBody";

type FilterMenuProps = {
  children: React.ReactNode;
};

type Props = FilterMenuProps;

const MobileFilterMenu: React.FC<Props> = ({ children }) => {
  const isFilterMenuVisible = useSelector(selectFilterVisible);
  const dispatch = useDispatch();
  const bind = useOnClickOutside(() => dispatch(hideFilterMenu()));
  //const lock = useLockBody(isFilterMenuVisible);

  return (
    <Transition in={isFilterMenuVisible} timeout={300}>
      {(transitionState) => (
        <div className={"MobileFilterMenuUnderlay " + transitionState}>
          <div className={"MobileFilterMenuContainer " + transitionState} {...bind}>
            {/* <div id="MobileFilterMenu" className="MobileFilterMenu" {...lock}> */}
            <div id="MobileFilterMenu" className="MobileFilterMenu">
              {children}
            </div>
          </div>
        </div>
      )}
    </Transition>
  );
};

export default MobileFilterMenu;
